export default __webpack_public_path__ + "static/media/greenLightning.f8ca080b.svg";